/* Belle Chateau Noir — AJAX add-to-cart that opens the cart drawer.
   Intercepts submit on forms with class .bcn-add-form, adds via /cart/add.js
   (requesting the cart-drawer + cart-icon-bubble sections), then hands the
   response to Dawn's <cart-drawer> renderContents() which re-renders + opens. */
(function () {
  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest('form.bcn-add-form');
    if (!form) return;
    event.preventDefault();

    var cart = getCartDrawer();
    var button = form.querySelector('[name="add"], [type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');

    var formData = new FormData(form);
    if (cart) {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          // Add failed (e.g. sold out) — fall back to the cart page.
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (cart && response.sections) {
          // Cart is no longer empty — clear the wrapper's empty state so the
          // re-rendered line items show (renderContents only clears .drawer__inner).
          cart.classList.remove('is-empty');
          cart.renderContents(response);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  });
})();
